module.exports = __webpack_public_path__ + "img/i_letter.ce6e7c26.svg";